import React from 'react';
import _ from 'lodash';
import ContactPaxRegardingInvalidEmailTask from './tasks/ContactPaxRegardingInvalidEmailTask';
import CallPaxTask from './tasks/CallPaxTask';
import { graphql, compose, withApollo } from 'react-apollo';
import { Segment } from 'semantic-ui-react';
import HandleMessageTask from './tasks/HandleMessageTask';
import AssignMessageTask from './tasks/AssignMessageTask';
import HandleUnsuccessfulLOAValidationTask from './tasks/HandleUnsuccessfulLOAValidationTask';
import { Task } from '../queries/Task';
import SendLoaTask from './tasks/SendLoaTask';
import CorrectClaimTask from './tasks/CorrectClaimTask';
import Content from './Content';
import * as messageActions from '../actions/message-actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DocumentTitle from './DocumentTitle';
import RedirectWithFilters from './RedirectWithFilters';
import HandleNeb from './tasks/HandleNebTask';
import CheckClaimBeforeClosureTask from './tasks/CheckClaimBeforeClosureTask';
import CreateLegalFormalNotice from './tasks/CreateLegalFormalNotice';
import CreateCourtApplication from './tasks/CreateCourtApplication';

class TaskView extends React.Component {
  state = {
    task: 0
  };
  render = () => {
    if (this.state.redirect) {
      const previousPath = _.get(this.props, 'location.state.previousPath');
      const to = previousPath ? previousPath : 'tasks';
      return <RedirectWithFilters to={to} />;
    }
    return (
      <div>
        <DocumentTitle title={`Task ${this.props.match.params.id}`} />
        {this.renderTask()}
      </div>
    );
  };

  handleBack = () => this.setState({ redirect: true });

  handleTaskComplete = () => {
    this.props.actions.showMessage({
      header: 'Success',
      text: 'Task Completed',
      props: { success: true },
      duration: 2000
    });
    this.setState({ redirect: true });
  };

  handleClaimClosed = () => {
    this.props.actions.showMessage({
      header: 'Success',
      text: 'Claim closed',
      props: { success: true },
      duration: 2000
    });
    this.setState({ redirect: true });
  };

  renderTask = () => {
    const task = this.props.Task.task;
    const taskType = task && task.taskType;
    if (!task) {
      return <Content loading={true} />;
    }
    if (task.status === 'closed') {
      return <Segment> This task is closed </Segment>;
    }
    if (!taskType) {
      return <Segment> Generic task not yet supported </Segment>;
    }
    const taskProps = {
      task,
      onTaskComplete: this.handleTaskComplete,
      onClaimClosed: this.handleClaimClosed,
      handleBackToTasks: this.handleBack
    };

    switch (taskType.name) {
      case 'contact-pax-regarding-invalid-email':
        return <ContactPaxRegardingInvalidEmailTask {...taskProps} />;
      case 'correct-claim':
        return <CorrectClaimTask {...taskProps} />;
      case 'call-pax':
        return <CallPaxTask {...taskProps} />;
      case 'send-loa':
        return <SendLoaTask {...taskProps} />;
      case 'handle-unsuccessful-loa-validation':
        return <HandleUnsuccessfulLOAValidationTask {...taskProps} />;
      case 'handle-message':
        return (
          <HandleMessageTask {...taskProps} location={this.props.location} />
        );
      case 'assign-message':
        return <AssignMessageTask {...taskProps} />;
      case 'handle-neb':
        return <HandleNeb {...taskProps} />;
      case 'check-claim-before-closure':
        return <CheckClaimBeforeClosureTask {...taskProps} />;
      case 'create-legal-formal-notice':
        return (
          <CreateLegalFormalNotice
            {...taskProps}
            history={this.props.history}
          />
        );
      case 'create-court-application':
        return (
          <CreateCourtApplication {...taskProps} history={this.props.history} />
        );
      default:
        return <Segment> No such task type: {taskType.name}</Segment>;
    }
  };
}

const TaskViewWithData = compose(
  withApollo,
  graphql(Task, {
    name: 'Task',
    options: props => {
      return {
        variables: {
          id: props.match.params.id
        }
      };
    },
    notifyOnNetworkStatusChange: true
  })
)(TaskView);

export default connect(
  null,
  dispatch => ({
    actions: bindActionCreators(messageActions, dispatch)
  })
)(TaskViewWithData);



// WEBPACK FOOTER //
// ./src/component/TaskView.js